import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import React from 'react';
import RouteAdmin from '../routeAdminPage';
import AutoSequenceRoute from '../autoSequenceRoute';
import RouteOverview from '../RouteOverview';
import { locale } from '../../common/localization/localizationService';

interface IRouteMainPageProps {
  activeTab: number;
  changeActiveTab: (activeTab: number) => void;
}

export default function RouteMainPage(props: IRouteMainPageProps): JSX.Element {
  const { activeTab, changeActiveTab } = props;

  return (
    <>
      <TabStrip
        selected={activeTab}
        onSelect={(e) => changeActiveTab(e.selected)}
      >
        <TabStripTab title={locale.general._routeAdmin}>
          {activeTab === 0 && <RouteAdmin />}
        </TabStripTab>
        <TabStripTab title={locale.autoSequenceRoute._autosequenceRoute}>
          {activeTab === 1 && <AutoSequenceRoute />}
        </TabStripTab>
        <TabStripTab title={locale.routeOverview._routeOverview}>
          {activeTab === 2 && <RouteOverview />}
        </TabStripTab>
      </TabStrip>
    </>
  );
}
